export default __webpack_public_path__ + "static/media/mascota.42296c32.jpg";